<template>
  <div id="cyclic-definition_info">
      <v-container>
        <v-layout row wrap >
         <v-flex xs6 offset-xs3>
          <v-card >
            <v-card-title><h4>{{ data.name }}</h4></v-card-title>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-tile>
                <v-list-tile-content>Id:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ data.id }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Name:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ data.name }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Aktywny:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ data.status | intToYesNo }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Nadzorcy: </v-list-tile-content>
                <v-list-tile-content class="align-end">{{ data.supervisory_team.name }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Interval</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ data.interval }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Start:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ data.start }}</v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
  </v-container>
  </div>
</template>

<script>

export default {
  components: {
  },
  props:["infoData"],
  data() {
    return {
    }
  },
  computed: {
    data(){
      return this.infoData !=undefined ? this.infoData : {'supervisory_team':{}};
     }
  },
  methods: {
  },
  created() {
 }
}
</script>

<style>

</style>
